/**
 * Custom Resources Client-Side Filtering
 */
(function () {
    function initResourcesFilter() {
        const section = document.querySelector('.custom-resources');
        if (!section) return;

        const cards = Array.from(section.querySelectorAll('.resource-item-wrapper'));
        const tabs = section.querySelectorAll('.custom-resources-tab');
        const categoryCheckboxes = section.querySelectorAll('.filter-category-input');
        const tagCheckboxes = section.querySelectorAll('.filter-tag-input');
        const searchInput = section.querySelector('.search-box-input');
        const countDisplay = section.querySelector('.resources-count-number');
        const categoryFilterGroup = section.querySelector('.filter-group--category');
        const tagsFilterGroup = section.querySelector('.filter-group--tags');
        const mobileToggle = section.querySelector('.filter-mobile-toggle');
        const sidebar = section.querySelector('.resources-sidebar');
        const sidebarClose = section.querySelector('.resources-sidebar-close');
        const sidebarOverlay = section.querySelector('.resources-sidebar-overlay');

        let activeTabCategory = 'all';
        let activeCategories = [];
        let activeTags = [];
        let searchQuery = '';

        const updateVisibility = () => {
            let visibleCount = 0;
            cards.forEach(cardWrapper => {
                const card = cardWrapper.querySelector('.resource-card');
                const cardCategory = card.dataset.category;
                const cardTags = card.dataset.tags.split(',').filter(t => t !== '').map(t => t.trim());
                const cardTitle = card.querySelector('.resource-card__title').textContent.toLowerCase();

                let showByTab = activeTabCategory === 'all' || cardCategory === activeTabCategory;

                // If a tab is selected, it should override the category checkboxes OR work with them?
                // Usually tabs are quick filters. Let's make it work together (AND logic).

                let showByCategory = activeCategories.length === 0 || activeCategories.includes(cardCategory);
                let showByTag = activeTags.length === 0 || activeTags.some(tag => cardTags.includes(tag.trim()));
                let showBySearch = searchQuery === '' || cardTitle.includes(searchQuery);

                if (showByTab && showByCategory && showByTag && showBySearch) {
                    cardWrapper.style.display = 'block';
                    visibleCount++;
                } else {
                    cardWrapper.style.display = 'none';
                }
            });

            if (countDisplay) {
                countDisplay.textContent = visibleCount;
            }
        };

        const updateFilterList = () => {
            // Hide/Show Category filter group
            if (categoryFilterGroup) {
                const isAll = activeTabCategory === 'all';
                categoryFilterGroup.style.display = isAll ? 'block' : 'none';

                // If switching to a specific tab, reset sidebar category filters
                if (!isAll) {
                    categoryCheckboxes.forEach(cb => {
                        cb.checked = false;
                    });
                    activeCategories = [];
                }
            }

            // Update Tags filter group
            if (tagsFilterGroup) {
                const tagItems = tagsFilterGroup.querySelectorAll('.filter-item');

                tagItems.forEach(item => {
                    const checkbox = item.querySelector('.filter-tag-input');
                    const label = item.querySelector('label');
                    const tagValue = checkbox.value;

                    // Count how many cards in the current activeTabCategory have this tag
                    let tagCount = 0;
                    cards.forEach(cardWrapper => {
                        const card = cardWrapper.querySelector('.resource-card');
                        const cardCategory = card.dataset.category;
                        const cardTags = card.dataset.tags.split(',').filter(t => t !== '').map(t => t.trim());

                        let matchesCategory = false;
                        if (activeTabCategory !== 'all') {
                            matchesCategory = cardCategory === activeTabCategory;
                        } else {
                            matchesCategory = activeCategories.length === 0 || activeCategories.includes(cardCategory);
                        }

                        if (matchesCategory && cardTags.includes(tagValue)) {
                            tagCount++;
                        }
                    });

                    if (tagCount > 0) {
                        item.style.display = 'flex';
                        // Update label text safely
                        const labelText = label.querySelector('.facet-checkbox-label');
                        if (labelText) {
                            labelText.textContent = `${tagValue} (${tagCount})`;
                        } else {
                            label.textContent = `${tagValue} (${tagCount})`;
                        }
                    } else {
                        item.style.display = 'none';
                        if (checkbox.checked) {
                            checkbox.checked = false;
                            activeTags = activeTags.filter(t => t !== tagValue);
                        }
                    }
                });
            }
        };

        // Initial update
        updateFilterList();

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                activeTabCategory = tab.dataset.category;
                updateFilterList();
                updateVisibility();
            });
        });

        categoryCheckboxes.forEach(cb => {
            cb.addEventListener('change', () => {
                activeCategories = Array.from(categoryCheckboxes)
                    .filter(i => i.checked)
                    .map(i => i.value);
                updateFilterList();
                updateVisibility();
            });
        });

        tagCheckboxes.forEach(cb => {
            cb.addEventListener('change', () => {
                activeTags = Array.from(tagCheckboxes)
                    .filter(i => i.checked)
                    .map(i => i.value);
                updateVisibility();
            });
        });

        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                searchQuery = e.target.value.toLowerCase();
                updateVisibility();
            });
        }

        // Mobile Drawer Logic
        const toggleDrawer = (isOpen) => {
            if (sidebar) sidebar.classList.toggle('is-open', isOpen);
            if (sidebarOverlay) sidebarOverlay.classList.toggle('is-visible', isOpen);
            if (mobileToggle) mobileToggle.classList.toggle('is-active', isOpen);
            document.body.style.overflow = isOpen ? 'hidden' : '';
        };

        if (mobileToggle) {
            mobileToggle.addEventListener('click', () => {
                const isOpen = sidebar ? sidebar.classList.contains('is-open') : false;
                toggleDrawer(!isOpen);
            });
        }

        if (sidebarClose) {
            sidebarClose.addEventListener('click', () => toggleDrawer(false));
        }

        if (sidebarOverlay) {
            sidebarOverlay.addEventListener('click', () => toggleDrawer(false));
        }

        // Modal Logic
        const modal = section.querySelector('#ResourceModal');
        if (!modal) return;

        const modalTitle = modal.querySelector('.resource-modal__title');
        const modalDescription = modal.querySelector('.resource-modal__description');
        const modalDescriptionWrapper = modal.querySelector('.resource-modal__description-wrapper');
        const modalActions = modal.querySelector('.resource-modal__actions');
        const modalInfoLine = modal.querySelector('.resource-modal__info-line');
        const modalDownloadBtn = modal.querySelector('.resource-modal__download-btn');
        let currentFileUrl = null;
        const modalMedia = modal.querySelector('.resource-modal__media');
        const modalImageDownloads = modal.querySelector('.resource-modal__image-downloads');
        const closeModalBtn = modal.querySelector('.resource-modal__close');
        const modalOverlay = modal.querySelector('.resource-modal__overlay');

        function getYouTubeId(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            const match = url.match(regExp);
            return (match && match[2].length === 11) ? match[2] : null;
        }

        function openModal(card) {
            const data = card.dataset;
            modalTitle.textContent = data.title;

            if (data.description && data.description.trim() !== "") {
                modalDescription.innerHTML = data.description;
                modalDescriptionWrapper.style.display = 'block';
            } else {
                modalDescriptionWrapper.style.display = 'none';
            }

            // Reset logic
            modalMedia.innerHTML = '';
            modalActions.style.display = 'none';
            modalImageDownloads.style.display = 'none';

            const youtubeId = getYouTubeId(data.externalUrl || '');
            const isDownloadableAsset = data.fileType === 'PDF' || data.fileType === 'ZIP';
            const imageUrl = data.image;

            if (youtubeId) {
                modalMedia.innerHTML = `<div class="video-responsive"><iframe width="560" height="315" src="https://www.youtube.com/embed/${youtubeId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
            } else if (isDownloadableAsset) {
                modalActions.style.display = 'flex';

                let infoHtml = `<span>${data.category}</span> | <span>${data.fileType}</span>`;
                if (data.fileSize && data.fileSize.trim() !== "" && data.fileSize !== "0.0 MB") {
                    infoHtml += ` | <span>${data.fileSize}</span>`;
                }
                modalInfoLine.innerHTML = infoHtml;

                if (data.fileUrl) {
                    currentFileUrl = data.fileUrl;
                    modalDownloadBtn.style.display = 'flex';
                } else {
                    currentFileUrl = null;
                    modalDownloadBtn.style.display = 'none';
                }

                modalMedia.innerHTML = `<img src="${imageUrl}" class="modal-main-image">`;
            } else {
                // Default image view with download options
                modalMedia.innerHTML = `<img src="${imageUrl}" class="modal-main-image">`;
                modalImageDownloads.style.display = 'block';

                const linkPng = modal.querySelector('.download-link-png');
                const linkJpg = modal.querySelector('.download-link-jpg');
                const linkWebp = modal.querySelector('.download-link-webp');

                const baseImg = imageUrl.split('?')[0];
                const params = imageUrl.split('?')[1] ? `?${imageUrl.split('?')[1]}` : '';

                const getFormatUrl = (fmt) => `${baseImg}${params}${params ? '&' : '?'}format=${fmt}`;

                function setupImgDownload(linkEl, fmt) {
                    const url = getFormatUrl(fmt);
                    // Remove any old listener by cloning the node
                    const fresh = linkEl.cloneNode(true);
                    linkEl.parentNode.replaceChild(fresh, linkEl);
                    fresh.addEventListener('click', function (e) {
                        e.preventDefault();
                        const original = fresh.textContent;
                        fresh.textContent = 'Downloading...';
                        fetch(url)
                            .then(function (res) {
                                if (!res.ok) throw new Error('Network error');
                                return res.blob();
                            })
                            .then(function (blob) {
                                const objUrl = URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = objUrl;
                                a.download = 'image.' + fmt;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                setTimeout(function () { URL.revokeObjectURL(objUrl); }, 1000);
                            })
                            .catch(function () {
                                window.open(url, '_blank');
                            })
                            .finally(function () {
                                fresh.textContent = original;
                            });
                    });
                }

                setupImgDownload(linkPng, 'png');
                setupImgDownload(linkJpg, 'jpg');
                setupImgDownload(linkWebp, 'webp');
            }

            modal.style.display = 'flex';
            setTimeout(() => modal.classList.add('is-open'), 10);
            document.body.style.overflow = 'hidden';
        }

        function closeModal() {
            modal.classList.remove('is-open');
            setTimeout(() => {
                modal.style.display = 'none';
                modalMedia.innerHTML = ''; // Stop video
            }, 300);
            document.body.style.overflow = '';
        }

        cards.forEach(cardWrapper => {
            const card = cardWrapper.querySelector('.resource-card');
            card.addEventListener('click', (e) => {
                openModal(card);
            });
        });

        // Download via fetch+Blob to force download (works for cross-origin CDN files)
        modalDownloadBtn.addEventListener('click', function () {
            if (!currentFileUrl) return;
            const btn = this;
            btn.disabled = true;
            btn.textContent = 'Downloading...';
            fetch(currentFileUrl)
                .then(function (response) {
                    if (!response.ok) throw new Error('Network error');
                    return response.blob();
                })
                .then(function (blob) {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    // Extract filename from URL
                    const parts = currentFileUrl.split('?')[0].split('/');
                    let defaultName = 'download.pdf';
                    if (currentFileUrl.includes('.zip')) defaultName = 'download.zip';
                    a.download = parts[parts.length - 1] || defaultName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
                })
                .catch(function () {
                    // Fallback: open in new tab
                    window.open(currentFileUrl, '_blank');
                })
                .finally(function () {
                    btn.disabled = false;
                    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> Download';
                });
        });

        closeModalBtn.addEventListener('click', closeModal);
        modalOverlay.addEventListener('click', closeModal);
    }

    // Initialize on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', initResourcesFilter);

    // Also init on theme editor load
    document.addEventListener('shopify:section:load', initResourcesFilter);
})();
